module.exports = __webpack_public_path__ + "static/media/img-1.8b8d8e2d.jpg";